export function isTimeoutError(
  error: unknown,
): error is Pick<Error, "message"> {
  return (
    !!error &&
    typeof error === "object" &&
    "message" in error &&
    typeof error.message === "string" &&
    error.message.includes("Timed out")
  )
}
